<mat-toolbar>
  <button mat-raised-button matTooltip="Volver" (click)="back()" color='primary'><mat-icon>arrow_back</mat-icon> Volver</button>
  <span class="spacer"></span>
  <button mat-icon-button matTooltip="Recargar datos" (click)="ngOnInit()"><mat-icon color="primary">refresh</mat-icon></button>
  <button mat-button [matMenuTriggerFor]="beforeMenu"><mat-icon color="primary">menu</mat-icon></button>
  <mat-menu #beforeMenu="matMenu" xPosition="before">
    <button mat-menu-item (click)='finalizarClasificacion()'>Finalizar clasificación</button>
  </mat-menu>
</mat-toolbar>

<div class="pageContent">
  @if (showProgressBar) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }

  @if (clasificacion.length === 0) {
    <p>No hay datos disponibles...</p>
  }

  <h1> Albarán Nº{{ albaran }} </h1>

  <mat-accordion>
    @for (data of clasificacion; track data; let i = $index) {
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ data.residuo }}
          </mat-panel-title>
          <mat-panel-description>
            {{ data.neto }}Kg
          </mat-panel-description>
        </mat-expansion-panel-header>
        <mat-divider></mat-divider>
        <div class='casiHeaeder'>
          <h2> Clasificación </h2>
          <button mat-raised-button matTooltip="Añadir registro" (click)="newRegistro(data.id_residuo)" color='primary'>Añadir</button>
        </div>
        @for (clasi of data.clasificado; track clasi; let i = $index) {
          <div class='bodyInfo'>
            <div class='imageBlock'>
              @if (clasi.foto1.length > 5) {
                <img src="{{clasi.foto1}}" alt='FOTO 1 TOMADA POR EL CLASIFICADOR' title='FOTO 1 TOMADA POR EL CLASIFICADOR' class='imageCaptured'>
              }
              @if (clasi.foto2.length > 5) {
                <img src="{{clasi.foto2}}" alt='FOTO 2 TOMADA POR EL CLASIFICADOR' title='FOTO 2 TOMADA POR EL CLASIFICADOR' class='imageCaptured'>
              }
            </div>
            <div>
              <table class='table'>
                <tr>
                  <td class='mainCell'>Residuo:</td>
                  <td> {{ clasi.residuo_clasificado }} </td>
                </tr>
                <tr>
                  <td class='mainCell'>Peso:</td>
                  <td> {{ clasi.peso }}Kg </td>
                </tr>
                <tr>
                  <td class='mainCell'>Descripción:</td>
                  <td> {{ clasi.descripcion }} </td>
                </tr>
              </table>
            </div>
            @if ((i+1) < data.clasificado.length) {
              <mat-divider></mat-divider>
            }
            @if ((i+1) < data.clasificado.length) {
              <mat-divider></mat-divider>
            }
          </div>
        }
      </mat-expansion-panel>
    }
  </mat-accordion>
</div>
